import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LocationService } from '../../../service/api/location-service';
import { redux } from 'Core/redux';

export const STORE_KEY = 'location';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
};

export const fetchLocations = createAsyncThunk('location/fetchLocations', async (data) => {
  const { response } = await LocationService.getAllLocations(data);
  return response;
});

export const { reducer, actions } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLocations.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

redux.injectReducer(STORE_KEY, reducer);
